import { Injectable } from '@angular/core';
import { API } from './api';
import { BaseProvider } from './base';
import { DatasetProvider } from './dataset';

export class DatasetComment {
    id: string;
    text: string;
    user: any;
    datasetId: string;
    timestamp: string; // we will take the date_updated
    deleted = false;
}

@Injectable()
export class DatasetCommentProvider extends BaseProvider {
    public datasetComments: DatasetComment[] = [];
    public datasetCommentIndexes: object = {};

    constructor(public api: API, public datasetProvider: DatasetProvider) {
        super();
    }
    // Fetch comments for a specific dataset
    public async fetchDatasetComments(datasetIdentifier: string): Promise<DatasetComment[]> {
        try {
            await this.ensureDependenciesLoaded([this.datasetProvider]);

            // set up the query string and the route
            const route = `datasets/${datasetIdentifier}/comments`;

            const response = await this.api.get(route);

            this.datasetCommentIndexes = {};
            this.datasetComments = response.message.comments.map((d, index) => {
                this.datasetCommentIndexes[d.public_identifier] = index;
                return this.toDatasetComment(d);
            });
            return this.datasetComments;
        } catch (err) {
            throw err;
        }
    }

    // turn object result into comment format
    private toDatasetComment(obj: any): DatasetComment {
        const datasetComment = new DatasetComment();
        datasetComment.id = obj.public_identifier;
        datasetComment.text = obj.text;
        datasetComment.datasetId = obj.dataset_id;
        datasetComment.timestamp = obj.date_updated;
        datasetComment.user = obj.user;
        if (obj.date_deactivated) {
            datasetComment.deleted = true;
        }

        return datasetComment;
    }
    // get comment by ID
    public getDatasetCommentById(id: string): DatasetComment {
        const index = this.datasetCommentIndexes[id];
        return this.datasetComments[index];
    }
    // Create a comment on a dataset.

    public async createDatasetComment(datasetIdentifier: string, text: string) {
        const route = `datasets/${datasetIdentifier}/comments`;
        const response = await this.api.post(route, { text });
        return response;
    }

    // Publish edits for a specific comment on a dataset
    public async editDatasetComment(datasetIdentifier: string, datasetCommentIdentifier: string, text: string) {
        try {
            const route = `datasets/${datasetIdentifier}/comments/${datasetCommentIdentifier}/edit`;
            await this.api.post(route, { text });
        } catch (e) {
            throw e;
        }
    }

    // Delete a comment on a dataset.
    public async deactivateDatasetComment(datasetIdentifier: string, datasetCommentIdentifier: string) {
        try {
            await this.api.delete(`datasets/${datasetIdentifier}/comments/${datasetCommentIdentifier}`);
            const index = this.datasetCommentIndexes[datasetCommentIdentifier];
            if (this.datasetComments.length > 1) {
                this.datasetComments.splice(index, 1);
            } else {
                this.datasetComments = [];
            }

            this.recalculateCommentIndexes();
        } catch (e) {
            throw e;
        }
    }

    private recalculateCommentIndexes() {
        this.datasetCommentIndexes = {};
        this.datasetComments.forEach((comment, index) => {
            this.datasetCommentIndexes[comment.id] = index;
        });
    }
}



// WEBPACK FOOTER //
// ./src/providers/dataset_comment.ts